import { FC } from 'react'
import { Post } from '@wellesley/openapi'

import isQuote from '../helpers/isQuote'
import { TPostForm } from '../../PostForm/types'
import DeletedContent from '../DeletedContent'
import { FeedProps, UserWrapperProps } from '../TimelineFeed/types'
import {
  getReplyFeedTitle,
  getReplyFeedSubtitle,
} from '../Header/helpers/getCustomTitle'

type TRepostedContent = {
  feed: Post
  canPinPost?: boolean
  hidePrivatePosts?: boolean
  renderFeed: (props: FeedProps) => JSX.Element
  renderUserWrapper: (props: UserWrapperProps) => JSX.Element
  renderEditModal?: (props: TPostForm) => JSX.Element
}

const isReply = (feed?: Post | null) => !!feed?.path.length

const getHeaderTitle = (feed: Post) =>
  isReply(feed.originalPost)
    ? getReplyFeedTitle(feed.originalPost)
    : isQuote(feed)
      ? undefined
      : getReplyFeedTitle(feed.originalPost)

const getHeaderSubtitle = (feed: Post) =>
  isReply(feed.originalPost)
    ? getReplyFeedSubtitle(feed)
    : isQuote(feed)
      ? undefined
      : getReplyFeedSubtitle(feed.originalPost)

const RepostedContent: FC<TRepostedContent> = ({
  feed,
  canPinPost,
  hidePrivatePosts,
  renderFeed,
  renderUserWrapper,
  renderEditModal,
}) => {
  if (feed.originalPost?.deleted) return <DeletedContent isRepostFeed />

  return renderFeed({
    ...feed.originalPost!,
    renderEditModal,
    renderUserWrapper,
    canPinPost,
    hidePrivatePosts,
    card: feed.card ? null : (feed.originalPost?.card ?? null), // show only in main feed preview if exists
    headerTitle: getHeaderTitle(feed),
    headerSubtitle: getHeaderSubtitle(feed),
    isFooter: false,
    isQuotePost: true,
    repostOf: '',
    originalPost: null,
    isSmallImagePreview: false,
    className: 'rounded-lg border border-gray-300 p-4',
    children: null,
  })
}

export default RepostedContent
